<script setup>
import { isEqualStr } from '../shared/utils';
import { computed, inject } from 'vue';
import { useModal, useModalSlot } from 'vue-final-modal';
import Modal from './Modal.vue'
import OpeningHours from './OpeningHours.vue';
import iconClock from '@client/svg/clock.svg?raw';
import iconChevron from '@client/svg/chevron.svg?raw';

let rootData = inject('rootData');

let timeFormat = window['_EZCL']?.data?.ordering?.schedule?.use24hFormat ? '24h' : 'ampm'; 
const { open, close } = useModal({
    component: Modal,
    attrs: {
        onClose() {
            close()
        },
    },
    slots: {
        default: useModalSlot({
            component: OpeningHours,
            attrs: {
                timezone: rootData?.timezone,
                oh: rootData?.address?.oh,
                dayparts: rootData?.ordering?.dayparts,
                timeFormat,
                onClose() {
                    close()
                }
            }
        })
    }
});

const props = defineProps({
    timezone: String,
    oh: {
        type: Array,
        default: []
    }
});

let today = new Intl.DateTimeFormat('en-US', { weekday: "long" }).format(new Date());

const openedNow = function (fromTime, toTime, weekday) {
    let fromParts = fromTime.split(":");
    let toParts = toTime.split(":");

    let now = new Date();
    let today = new Intl.DateTimeFormat('en-US', { weekday: "long" }).format(now);
    if (isEqualStr(weekday, today) &&
        typeof fromParts[0] !== 'undefined' &&
        typeof fromParts[1] !== 'undefined' &&
        typeof toParts[0] !== 'undefined' &&
        typeof toParts[1] !== 'undefined'
    ) {
        let shiftStart = new Date();      // work shift end
        shiftStart.setHours(fromParts[0], fromParts[1], 0, 0);
        let shiftEnd = new Date();        // work shift start
        shiftEnd.setHours(toParts[0], toParts[1], 0, 0);

        if (shiftStart <= now && now <= shiftEnd) {
            return true;
        }
    }
    return false;
}

const isOpened = computed(() => {
    let opened = {
        'status': false,
        'time': {
            'from': '',
            'to': '',
        }
    };
    props.oh.forEach(day => {
        if (isEqualStr(today, day.name)) {
            if (day.status >= 1) {
                day.range.forEach(range => {
                    if (openedNow(range.from, range.to, day.name)) {
                        opened.time.from = range.from;
                        opened.time.to = range.to;
                        opened.status = true;
                    }
                })
            }
        }
    });
    return opened;
});

</script>

<template>
    <div class="ohWidget" @click="() => open()">
        <div class="ohWidgetClock iconw" v-html="iconClock"></div>
        <span class="ohWidgetStatus">{{ isOpened.status ? 'Open' : 'Closed' }}</span> 
        <span v-show="isOpened.status"><time v-text="isOpened.time.from"></time> - <time
                v-text="isOpened.time.to"></time></span>
        <div class="ohWidgetChevron iconw" v-html="iconChevron"></div>
    </div>
</template>
<style>
.ohWidget {
    cursor: pointer;
}
.ohWidgetClock {
    font-size: 0.75rem;
    margin-right: 0.375rem;
}
.ohWidgetStatus {
    font-weight: 500;
    margin-right: 0.375rem;
}
.ohWidgetChevron {
    margin-left: 0.375rem;
    font-size: 0.625rem;
    transform: rotate(90deg);
}
</style>